import React from 'react';
import { useTranslation } from 'react-i18next';

const ProgressBar = ({ current, total, containerStyle, align = 'center' }) => {
  const { t } = useTranslation();
  const fillPercentage =
    total > 0 && Number.isFinite(current)
      ? Math.min((current / total) * 100, 100)
      : 0;

  const getState = () => {
    if (fillPercentage === 0) {
      return {
        label: t('common.empty'),
        barColor: 'bg-green-700',
        textColor: 'text-green-700',
      };
    }
    if (fillPercentage <= 33) {
      return {
        label: t('common.almost_empty'),
        barColor: 'bg-green-400',
        textColor: 'text-green-400',
      };
    }
    if (fillPercentage <= 66) {
      return {
        label: t('common.half_full'),
        barColor: 'bg-yellow-400',
        textColor: 'text-yellow-400',
      };
    }
    if (fillPercentage < 100) {
      return {
        label: t('common.almost_full'),
        barColor: 'bg-orange-400',
        textColor: 'text-orange-400',
      };
    }
    return {
      label: t('common.full'),
      barColor: 'bg-red-500',
      textColor: 'text-red-500',
    };
  };

  const { label, barColor, textColor } = getState();

  return (
    <div className={`flex flex-col items-center w-[120px] min-w-[120px] max-w-[120px] flex-shrink-0 ${containerStyle || ''}`}>
      <p className={`w-full ${align === 'left' ? 'text-left' : 'text-center'} text-[10px] leading-tight font-semibold whitespace-nowrap overflow-hidden text-ellipsis ${textColor}`}>
        {label}
      </p>
      <div className="w-full bg-gray-200 rounded-full h-4">
        <div
          className={`${barColor} h-4 rounded-full transition-all duration-300 ease-in-out`}
          style={{ width: `${fillPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
